import type { ReactNode } from 'react'

const TONES = {
    warning: 'border-warning-soft bg-warning-soft text-warning-soft-foreground',
    success: 'border-success-soft bg-success-soft text-success-soft-foreground',
    info: 'border-border bg-surface-secondary text-foreground-muted',
} as const

/** A notice box of the review drawer (v17 `.notice`): yellow for a warning, green for a match, grey for a plain note. */
export const ReviewNotice = ({ tone, children }: { tone: keyof typeof TONES; children: ReactNode }) => (
    <div className={`my-4 rounded-[9px] border p-3 text-xs leading-relaxed ${TONES[tone]}`}>{children}</div>
)

/** A section label of the review drawer (v17 `.sectionlabel`): small, uppercase and muted. */
export const SectionLabel = ({ children }: { children: ReactNode }) => (
    <h4 className="mb-3 mt-6 text-[11px] font-medium uppercase tracking-[0.8px] text-foreground-muted">{children}</h4>
)
